import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
        },

        logoutUser: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            localStorage.clear();
        },

        updateToken: (state, action) => {
            state.token = action.payload;
            localStorage.setItem("token", action.payload);
        },
    },
});

export const {setUser, logoutUser, updateToken} = userSlice.actions;

// Selectors
export const selectUser = (state) => state.user.user;
export const selectToken = (state) => state?.user?.token || null;
export const selectRefreshToken = (state) => state?.user?.refreshToken || null;

export default userSlice.reducer;
